/**
 *  PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *  Copyright © 2024 Pearson Education, Inc.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 * */
/**
 * @file StyleConstants.jsx - A component that handles style constants.
 */

export const colors = {
  WHITE: '#FFFFFF',
  BLACK: '#000000',
  SIDE_PANEL: {
    BG_COLOR: '#2d2d2d',
    BUTTON_COLOR: '#f8fafc',
    BUTTON_HOVER_COLOR: '#4a4a4a',
    CONDITIONAL_BOX_BG_ACTIVE: '#333b44',
    CONDITIONAL_BOX_BG_INACTIVE: '#333333',
    CONDITIONAL_BOX_BORDER_ACTIVE: '#a78bfa',
    CONDITIONAL_BOX_BORDER_INACTIVE: '#4b5563',
    DISABLED_COLOR: 'rgba(255, 255, 255, 0.5)'
  },
  GO_DEEPER_PILLS: {
    SCROLL_BAR_TRACK_BG: '#F7F9FD',
    SCROLL_BAR_THUMB_BG: 'rgba(0, 0, 0, 0.6)',
    PILLS_BUTTON_BG: '#FEFEFE',
    PILLS_BUTTON_HOVER_BG: '#BCC1CB',
    PILLS_BUTTON_TEXT_COLOR: '#020917',
    PILLS_BUTTON_BORDER: '2px solid #C7CCD6'
  }
};

export const sidePanel = {
  borderDividerColor: '#374151',
  conditionalEdgeColor: '#f8fafc',
  conditionalEdgeDescription: '#9ca3af',
  conditionalEdgeTip: '#6b7280'
};

export const groupColors = [
  'rgb(224, 231, 255, 0.3)', // #e0e7ff
  'rgb(252, 231, 243, 0.3)', // #fce7f3
  'rgb(254, 249, 195, 0.3)', // #fef9c3
  'rgb(209, 250, 229, 0.3)', // #d1fae5
  'rgb(254, 226, 226, 0.3)', // #fee2e2
  'rgb(224, 242, 254, 0.3)', // #e0f2fe
  'rgb(240, 253, 244, 0.3)' // #f0fdf4
];

export const groupColorsLight = [
  'rgb(224, 231, 255, 0.9)', // #e0e7ff
  'rgb(252, 231, 243, 0.9)', // #fce7f3
  'rgb(254, 249, 195, 0.9)', // #fef9c3
  'rgb(209, 250, 229, 0.9)', // #d1fae5
  'rgb(254, 226, 226, 0.9)', // #fee2e2
  'rgb(224, 242, 254, 0.9)', // #e0f2fe
  'rgb(240, 253, 244, 0.9)' // #f0fdf4
];

export const THEME_BTN = {
  position: 'absolute',
  top: '20px',
  left: '20px',
  zIndex: 10,
  padding: '10px 13px',
  color: 'white',
  background: 'linear-gradient(to bottom, #007a8f, #012b5b)',
  border: 'none',
  borderRadius: '50%',
  cursor: 'pointer',
  transition: 'background-color 0.2s',
  boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
};

export const INFO_BTN = {
  position: 'absolute',
  color: 'white',
  top: '10px',
  left: '10px',
  zIndex: 10,
  cursor: 'pointer'
};

export const TEST_BTN = {
  position: 'fixed',
  top: '15%',
  right: '20px',
  zIndex: 1000,
  padding: '10px 20px',
  background: 'linear-gradient(to bottom, #007a8f, #012b5b)',
  border: 'none',
  borderRadius: '4px',
  color: 'white',
  fontWeight: 'bold',
  cursor: 'pointer',
  transition: 'background-color 0.2s',
  boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
};

export const IMPLEMENTATION_BUTTONS = { marginBottom: '10px', display: 'flex', gap: '10px' };

export const INSTRUCTIONS_TOOLTIP = {
  tooltip: {
    backgroundColor: '#333',
    color: '#fff',
    fontSize: '14px',
    padding: '12px',
    borderRadius: '4px',
    maxWidth: '300px'
  },
  tooltipTitle: {
    margin: '0 0 8px 0',
    fontWeight: 'bold'
  },
  list: {
    margin: 0,
    paddingLeft: '20px',
    listStyleType: 'decimal'
  },
  listItem: {
    marginBottom: '8px'
  }
};
